export function formatEstimatedDelivery({
  min,
  max,
  unit,
}: {
  min: number
  max: number
  unit: string
}) {
  const translatedUnit =
    unit === "day" ? (max === 1 ? "day" : "days") : max === 1 ? "week" : "weeks"

  if (min === max) {
    return `${min} ${translatedUnit}`
  }

  return `${min}-${max} ${translatedUnit}`
}
